module.exports = __webpack_public_path__ + "assets/img/emptyCart.5ece64f5.svg";